import { SPage } from "servisofts-component";
import root from "./root";
//import novedades from "./novedades";
import popup_inicio from "./popup_inicio";
import info_inversiones from "./info_inversiones";
import tutoriales from "./tutoriales";
import title_tutoriales from "./title_tutoriales";
//import restaurante_mas_pedido from "./restaurante_mas_pedido";
//import company_patrocinado from "./company_patrocinado";
import racha_de_paquetes from "./racha_de_paquetes";

export default SPage.combinePages("marketing",
    {
        "": root,
        //...novedades,
        ...popup_inicio,
        ...tutoriales,
        ...info_inversiones,
        //...resaurante_mas_pedido,
        //...company_patrocinado
        ...title_tutoriales,
        racha_de_paquetes,
    }
)